import { ApiWrapper, Format, jContentFactoryTemplateView } from '../../types';
import { OF } from '../../util/network';
import { JBaseApi } from '../base';

export class JContentFactory extends JBaseApi {
    public create(params: { uri: string }): Promise<ApiWrapper<jContentFactoryTemplateView>> {
        return this.network.postCSRF({ o: 'contentFactory', f: 'createTemplate', ...params } as OF);
    }

    public get(params: { uri: string }): Promise<ApiWrapper<jContentFactoryTemplateView>> {
        return this.network.post({ o: 'article', f: 'get', ...params, format: Format.VIEW } as OF);
    }
}
